/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { DeleteCourseSectionOptions, DeleteCourseSectionStatus200, DeleteCourseSectionStatus422 } from '../models/DeleteCourseSection'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { deleteCourseSection } from '../clients/axios/deleteCourseSection'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const deleteCourseSectionMutationKey = () => [{ url: '/admin/course/:course_id/sections/:section_id' }] as const

export function deleteCourseSectionMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = deleteCourseSectionMutationKey()
  return mutationOptions<DeleteCourseSectionStatus200, ResponseErrorConfig<DeleteCourseSectionStatus422>, DeleteCourseSectionOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await deleteCourseSection({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @summary Delete Course Section
 * {@link /admin/course/:course_id/sections/:section_id}
 */
export function useDeleteCourseSection<TContext>(options: {
  mutation?: UseMutationOptions<DeleteCourseSectionStatus200, ResponseErrorConfig<DeleteCourseSectionStatus422>, DeleteCourseSectionOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteCourseSectionMutationKey()

  const baseOptions = deleteCourseSectionMutationOptions(config) as UseMutationOptions<DeleteCourseSectionStatus200, ResponseErrorConfig<DeleteCourseSectionStatus422>, DeleteCourseSectionOptions, TContext>

  return useMutation<DeleteCourseSectionStatus200, ResponseErrorConfig<DeleteCourseSectionStatus422>, DeleteCourseSectionOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<DeleteCourseSectionStatus200, ResponseErrorConfig<DeleteCourseSectionStatus422>, DeleteCourseSectionOptions, TContext>
}
